import React from 'react'
import qaCallout from './qa-callout'

const doc = {
  title: 'Q&A: Rotating Direction of Filled Region',
  slug: 'qa-rotating-direction-of-filled-region',
  tags: ['forum', 'q&a', 'question', 'answer'],
  category: 'q-and-a',
  content: (props) => {
    return <div>
      {qaCallout}
      <p>
        <a href="https://forums.autodesk.com/t5/revit-architecture-forum/rotating-direction-of-filled-region/m-p/9247375#M267312" target="_blank" rel="noreferrer">Read more of this thread on forums.autodesk.com</a>
      </p>
      <blockquote className="doc-blockquote doc-blockquote-user">
        <strong className="doc-blockquote-title">Asked by <a href="https://forums.autodesk.com/t5/user/viewprofilepage/user-id/523662" target="_blank" rel="noreferrer">@2j2mattones</a> on 10/14/2008 on the Revit Architecture Forum:</strong><br/>
        Is there a way to rotate the direction of which the filled region is oriented (i.e. a wood grain pattern from horizontal to vertical or even on a diagonal angle)?<br/>
        <br/>
        Thanks,<br/>
        <br/>
        JM
      </blockquote>
      
      <blockquote className="doc-blockquote">
        <strong className="doc-blockquote-title"><a href="https://forums.autodesk.com/t5/user/viewprofilepage/user-id/6702606" target="_blank" rel="noreferrer">@Pattycake_Kyle</a> on 7/19/2020:</strong><br/>
        Not native in Revit like you can with Model Patterns.<br/>
        <br/>
        We have a free rotate pattern tool, if you want to check it out @ pattycake.io.<br/>
        <br/>
        <img src="/img/forum_content/RotatingPATFile.gif" width="98%"/>
      </blockquote> 

    </div>
  }
}

export default doc;


// WEBPACK FOOTER //
// ./src/docs/qa-rotating-direction-of-filled-region.js